var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div role=\"dialog\" class=\"lbModal {{ ::vm.options.className }}\" ng-class=\"{ 'lbModal-scroll': vm.options.scroll }\" ng-if=\"vm.modalContent\">\n<div class=\"lbModal_wrapper\" ng-style=\"{ width: vm.options.width }\">\n<div class=\"lbModal_content\"></div>\n</div>\n</div>";
var id1="components/lbModal/lbModal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbModal/lbModal.html
// module id = 1063
// module chunks = 2